import { maybePropN } from '@ipfabric/utils/fp/prop';
import { selectTopologyMetadata } from 'components/Graph/model/selectors/graphMetadata/selectTopologyMetadata';
import { flow } from 'fp-ts/lib/function';

export const selectIsolateStpi = flow(
  selectTopologyMetadata,
  maybePropN('parameters', 'technologies', 'stpInstances', 'isolate'),
);
